// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../index';

import { RingSizeFragmentDoc } from './ringSize.fragment.generated';
export const RecommendedRingSizeFragmentDoc = `
    fragment recommendedRingSize on RecommendedRingSize {
  __typename
  id
  label(country: $country, locale: $locale)
  ringSize {
    ...ringSize
  }
}
    `;